import React from 'react'
import { Row, Tabs, Col, Card } from 'antd'
import { UserOutlined, MedicineBoxOutlined, ExperimentOutlined } from '@ant-design/icons'

// Mock Data
import {
  dashboardSummary,
  staffSummary,
  departmentSummary,
  wardSummary,
  alertMessages,
  recentAdmissions,
  upcomingSurgeries,
  tasksDueToday,
  activeTheatres
} from './mockdata'

// Components
import DashboardHeader from './components/DashboardHeader'
import StatisticsCards from './components/StatisticsCards'
import StaffOverview from './components/StaffOverview'
import DepartmentStatus from './components/DepartmentStatus'
import PatientsTab from './components/tabs/PatientsTab'
import BedManagementTab from './components/tabs/BedManagementTab'
import TheatreStatusTab from './components/tabs/TheatreStatusTab'

// Hooks
import useDashboardFilters from './hooks/useDashboardFilters'

const { TabPane } = Tabs

const HospitalDashboard = () => {
  const { timeRange, setTimeRange, departmentFilter, setDepartmentFilter } = useDashboardFilters()

  return (
    <div style={{ padding: '24px' }}>
      <DashboardHeader alerts={alertMessages} />

      <StatisticsCards dashboardSummary={dashboardSummary} />

      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <StaffOverview staffSummary={staffSummary} />
        <DepartmentStatus departmentSummary={departmentSummary} />
      </Row>

      <Tabs defaultActiveKey='1'>
        <TabPane
          tab={
            <span>
              <UserOutlined /> Patients & Admissions
            </span>
          }
          key='1'
        >
          <PatientsTab
            recentAdmissions={recentAdmissions}
            upcomingSurgeries={upcomingSurgeries}
            tasksDueToday={tasksDueToday}
          />
        </TabPane>

        <TabPane
          tab={
            <span>
              <MedicineBoxOutlined /> Bed Management
            </span>
          }
          key='2'
        >
          <BedManagementTab wardSummary={wardSummary} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <ExperimentOutlined /> Theatre Status
            </span>
          }
          key='3'
        >
          <TheatreStatusTab activeTheatres={activeTheatres} />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default HospitalDashboard
